// Minimal client for CLawdFactory backend public endpoints.
// Uses CRA env var REACT_APP_BACKEND_URL.

export function getBackendBaseUrl() {
  const env = process.env.REACT_APP_BACKEND_URL;
  // If not set, default to same-origin (works behind Nginx reverse proxy).
  return (env && env.trim()) || window.location.origin;
}

export async function fetchPublicStatus(signal) {
  const base = getBackendBaseUrl();
  const res = await fetch(`${base}/api/public/status`, { signal });
  if (!res.ok) throw new Error(`status ${res.status}`);
  return res.json();
}

export async function fetchPublicFeed({ limit = 50, signal } = {}) {
  const base = getBackendBaseUrl();
  const res = await fetch(`${base}/api/public/feed?limit=${encodeURIComponent(limit)}`, { signal });
  if (!res.ok) throw new Error(`feed ${res.status}`);
  const data = await res.json();
  return data.items || [];
}

export function openPublicStream() {
  const base = getBackendBaseUrl();
  return new EventSource(`${base}/api/public/stream`);
}
